



































import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({
    components: {JdhErrorMessage, JdhValidationProvider, JdhInputArea, JdhFieldStructure}
})
export default class JdsTextAreaField extends Mixins(UniqueIdMixin) {
    @Prop() label!: string
    @Prop() value!: string
    @Prop() rows!: string
    focus = false

    @Prop({type: Boolean, default: false}) allowLogging!: boolean

    @Prop({type: Boolean, default: false}) required!: boolean
    @Prop({default: false}) maxLength!: string
    @Prop({default: false}) minLength!: string
    @Prop() pattern!: string


    get rules () {
        return {
            ... (this.required && {required: { allowFalse: false }}),
            ... (this.maxLength && {max_length: this.maxLength}),
            ... (this.minLength && {min_length: this.minLength}),
            ... (this.pattern && {pattern: this.pattern}),
        }
    }

    emitInput(value: string) {
        this.$emit('input', value)
    }
}
